/**
 *  Implementation of ApiFetchCache that stores cache results in memory for the lifetime of the object.
 *
 *  This implementation will only cache GET requests, and will raise expire events automatically whenever a POST, PUT, PATCH, or DELETE is made
 *  to clear all URLs that TODO
 *
 *  For more complicated use cases you can use kirei-ApiFetch-reduxcache or your own cache solution.
 */
var MemoryFetchCache = /** @class */ (function () {
    function MemoryFetchCache() {
        this.items = [];
    }
    /**
     * Generate a cacheId that can be used to uniquely identify this cached item.
     * @param values
     */
    MemoryFetchCache.prototype.generateCacheId = function () {
        var values = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            values[_i] = arguments[_i];
        }
        var ret = '';
        for (var _a = 0, values_1 = values; _a < values_1.length; _a++) {
            var value = values_1[_a];
            var sValue = '';
            if (value) {
                if (typeof value === 'string') {
                    sValue = value;
                }
                else {
                    sValue = JSON.stringify(value);
                }
            }
            ret += "[" + sValue + "]";
        }
        return ret;
    };
    /**
     * Read the entry for id from the cache, returning null if it is not found.
     * @param id
     */
    MemoryFetchCache.prototype.readFromCache = function (input, init) {
        var cacheId = this.generateCacheId(input, init && init.body);
        var cachedItems = this.items.filter(function (item) { return item.id == cacheId; });
        if (cachedItems.length) {
            var cachedItem = cachedItems[0];
            if (cachedItem) {
                if (cachedItem.expireAt && cachedItem.expireAt > new Date(Date.now())) {
                    return cachedItem.data;
                }
            }
        }
        return null;
    };
    /**
     * Store data in the cache for id.
     * @param id
     * @param data
     * @param options
     */
    MemoryFetchCache.prototype.storeInCache = function (input, init, result, options) {
        var cacheId = this.generateCacheId(input, init && init.body);
        this.items = this.items.concat([
            {
                id: cacheId,
                data: result,
                expireAt: options.expireAt,
                expireOnEvents: options.expireOnEvents
            }
        ]);
    };
    /**
     * Remove all entries from the cache that are listining to any of the provided events.
     * @param events
     */
    MemoryFetchCache.prototype.raiseExpireEvents = function () {
        var events = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            events[_i] = arguments[_i];
        }
        this.items = this.items.filter(function (item) {
            if (!item.expireOnEvents) {
                return true;
            }
            // If any of the events being raised effect this item then exclude it from the results so it gets removed from the cache.
            for (var i = 0; i < events.length; ++i) {
                var event = events[i];
                if (item.expireOnEvents.filter(function (it) { return it == event; }).length) {
                    return false;
                }
            }
            return true;
        }).slice();
    };
    return MemoryFetchCache;
}());
export { MemoryFetchCache };
//# sourceMappingURL=MemoryFetchCache.js.map